import { defineStore } from 'pinia'
import axios from 'axios'

export const useBilling = defineStore('billing', {
  state: () => ({
    isLoading: false,
    plans: [],
    addOns: [],
    subscription: null,
    usage: null,
  }),
  getters: {
    currentPlan: (state) => state.subscription?.plan || null,
    isPaid: (state) => state.subscription?.plan?.tier && state.subscription.plan.tier !== 'free',
    isAppSumo: (state) => state.subscription?.plan?.tier === 'appsumo',
    hasPro: (state) => state.subscription?.has_pro || false,
    hasMultiLanguage: (state) => state.subscription?.has_multi_language || false,
    billingPeriod: (state) => state.subscription?.billing_period || 'monthly',
  },
  actions: {
    async getPlans() {
      this.isLoading = true
      try {
        const response = await axios.get('/billing/plans/')
        this.plans = response.plans || []
        this.addOns = response.add_ons || []
        return response
      } finally {
        this.isLoading = false
      }
    },
    async getSubscription() {
      this.isLoading = true
      try {
        const response = await axios.get('/billing/subscription/')
        this.subscription = response
        return response
      } finally {
        this.isLoading = false
      }
    },
    async getUsage() {
      this.isLoading = true
      try {
        const response = await axios.get('/billing/usage/')
        this.usage = response
        return response
      } finally {
        this.isLoading = false
      }
    },
    async checkout({ planTier, billingPeriod = 'monthly', includePro = false, includeMultiLanguage = false, successUrl, cancelUrl }) {
      const response = await axios.post('/billing/checkout/', {
        plan_tier: planTier,
        billing_period: billingPeriod,
        include_pro: includePro,
        include_multi_language: includeMultiLanguage,
        success_url: successUrl,
        cancel_url: cancelUrl,
      })
      return response
    },
    async publicCheckout({ planTier, billingPeriod = 'monthly', includePro = false, includeMultiLanguage = false, successUrl, cancelUrl }) {
      const response = await axios.post('/billing/public-checkout/', {
        plan_tier: planTier,
        billing_period: billingPeriod,
        include_pro: includePro,
        include_multi_language: includeMultiLanguage,
        success_url: successUrl,
        cancel_url: cancelUrl,
        referral_source: window.promotekit_referral || null,
      })
      return response
    },
    async claimCheckout(sessionId) {
      const response = await axios.post('/billing/claim-checkout/', {
        session_id: sessionId,
      })
      return response
    },
    async openPortal(returnUrl) {
      const response = await axios.post('/billing/portal/', {
        return_url: returnUrl,
      })
      return response
    },
    async changePlan(planTier) {
      const response = await axios.patch('/billing/subscription/', {
        plan_tier: planTier,
      })
      return response
    },
    async cancelSubscription() {
      const response = await axios.post('/billing/subscription/cancel/')
      return response
    },
    async addAddon(addOnType = 'pro') {
      const response = await axios.post('/billing/subscription/add-on/', { add_on_type: addOnType })
      return response
    },
    async removeAddon(addOnType = 'pro') {
      const response = await axios.delete('/billing/subscription/add-on/', { data: { add_on_type: addOnType } })
      return response
    },
    async addProAddon() {
      return this.addAddon('pro')
    },
    async removeProAddon() {
      return this.removeAddon('pro')
    },
  },
})
